import { render } from "./index.vue?vue&type=template&id=7bf66586&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7bf66586&lang=less"

import exportComponent from "/root/workspace/LiYuLoginSaaS_ql2g/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__